import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {RequestState} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IUserStore} from "data/stores/user/user.store";
import type {IMenuStore} from "data/stores/menu/menu.store";

export interface IMenuController extends ViewController {
	get i18n(): ILocalizationStore;
	get isAuthorized(): boolean;
	get isOpenMenu(): boolean;

	closeMenu: () => void;
}

@injectable()
export class MenuController implements IMenuController {
	@observable _requestState: RequestState = RequestState.IDLE;

	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.MenuStore) private _menuStore: IMenuStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get isAuthorized() {
		return this._userStore.isAuthorized;
	}

	get isOpenMenu(): boolean {
		return this._menuStore.isOpenMenu;
	}

	closeMenu = () => {
		this._menuStore.closeMenu();
	};

	dispose() {
		return;
	}

	init(param: void) {
		return;
	}
}
